import get from 'lodash/get';
import { push } from 'connected-react-router';
import { api } from '../../api';
import { actions } from '../../../store/actions';
import { getUserInfo, setUserData } from '../../utils';

export const signUpDriver = (
  values,
  setErrors,
  setSubmitting,
) => async dispatch => {
  try {
    await api.signUpDriver(values);
    const loginResponse = await api.login(values, 'driver');
    setUserData(loginResponse.data);
    dispatch(actions.login.act(getUserInfo()));
    dispatch(push('/'));
  } catch (err) {
    setErrors({
      backError: get(err, ['response', 'data', 'errorMsg'], 'Unknown error'),
    });
    setSubmitting(false);
  }
};
